import { render, staticRenderFns } from "./ChildrenInfoTableForm.vue?vue&type=template&id=7faef5b2"
import script from "./ChildrenInfoTableForm.vue?vue&type=script&lang=js"
export * from "./ChildrenInfoTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports